var map = {
	"./bg-adwya1.png": 50505,
	"./bg-adwya2.png": 1714,
	"./bg-adwya3.png": 50715,
	"./bg-med4is.png": 30686,
	"./bg-medis.png": 68900,
	"./bg-neapolis - Copie.png": 56128,
	"./bg-neapolis.png": 47793,
	"./bg-neapolis22.png": 93669,
	"./bg-teriak1.png": 84257,
	"./bg-teriak2.png": 35274,
	"./bg-teriak3.png": 90483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11203;